document.querySelectorAll('.hero-slideshow').forEach(gallery => {
  const images = gallery.querySelectorAll('img');
  let index = 0;

  if (images.length === 0) return; // skip empty galleries

  images[0].classList.add('active');

  setInterval(() => {
    images[index].classList.remove('active');
    index = (index + 1) % images.length;
    images[index].classList.add('active');
  }, 4000); // change every 4s
});
